// F8 : répartitions du dashboard et du panneau carte.

function trierCommunes(map, index) {
    return [...map.entries()]
        .map(([cle, nb]) => ({cle, commune: index.communeParCle.get(cle).libelle, nb}))
        .sort((a, b) => b.nb - a.nb || a.commune.localeCompare(b.commune));
}

function compter(map, cle, n = 1) {
    map.set(cle, (map.get(cle) || 0) + n);
}

function trierDesc(map, cleNom, cleNb = 'nb') {
    return [...map.entries()]
        .map(([nom, nb]) => ({[cleNom]: nom, [cleNb]: nb}))
        .sort((a, b) => b[cleNb] - a[cleNb] || String(a[cleNom]).localeCompare(String(b[cleNom])));
}

function ligne(pav, verdicts) {
    const inspectes = pav - verdicts.ni;
    return {
        pav,
        // Taux de service sur les états fournis (lavage) ; couverture = inspectés / parc.
        service: pav > 0 ? (verdicts.ras + verdicts.pb) / pav : null,
        couverture: pav > 0 ? inspectes / pav : null,
        enDefaut: verdicts.pb,
        impossibles: verdicts.imp,
    };
}

export function repartitions(pavsRetenus, etats, index) {
    const parVerdict = {ras: 0, pb: 0, imp: 0, ni: 0};
    const defautsParCommune = new Map();
    const defautsParElement = new Map();
    const communesTouchees = new Map();
    const parPatrimoine = new Map();
    const territoire = {ras: 0, pb: 0, imp: 0, ni: 0};

    for (const pav of pavsRetenus) {
        const etat = etats.get(pav.id);
        parVerdict[etat.verdict]++;
        territoire[etat.verdict]++;
        if (etat.verdict === 'pb') {
            if (pav.communeCle !== null) compter(defautsParCommune, pav.communeCle);
            for (const libelle of etat.elementsEnDefaut) compter(defautsParElement, libelle);
        }
        // « Touchée » = au moins un point en problème ou impossible.
        if (etat.verdict === 'pb' || etat.verdict === 'imp') { if (pav.communeCle !== null) compter(communesTouchees, pav.communeCle); }

        let v = parPatrimoine.get(pav.patrimoineId);
        if (!v) {
            v = {ras: 0, pb: 0, imp: 0, ni: 0};
            parPatrimoine.set(pav.patrimoineId, v);
        }
        v[etat.verdict]++;
    }

    const lignes = [...parPatrimoine.entries()].map(([patrimoineId, v]) => {
        const p = index.patrimoineById.get(patrimoineId);
        const nb = v.ras + v.pb + v.imp + v.ni;
        return {patrimoineId, libelle: p ? p.libelle : null, groupe: p ? p.groupe : null, ...ligne(nb, v)};
    }).sort((a, b) => String(a.libelle).localeCompare(String(b.libelle), 'fr', {numeric: true, sensitivity: 'base'}));

    lignes.push({
        patrimoineId: 'territoire',
        libelle: 'Territoire',
        groupe: null,
        ...ligne(pavsRetenus.length, territoire),
    });

    return {
        parVerdict,
        defautsParCommune: trierCommunes(defautsParCommune, index).slice(0, 5),
        defautsParElement: trierDesc(defautsParElement, 'libelle'),
        communesTouchees: trierCommunes(communesTouchees, index),
        parPatrimoine: lignes,
    };
}
